module.exports = __webpack_public_path__ + "static/media/women-fas-cat-6.7bbadd8b.png";